/* ============================================================
   BULKD — price-per-serve
   Renders "$X.XX / serve · N servings · <pack size>" under every
   product card and on the PDP, auto-calculated from price ÷ servings.
   Recalculates when the Seal Subscriptions "Membership" toggle
   changes the displayed price (no custom event is fired by Seal, so
   we watch the price node with a MutationObserver + the radio's
   change event). Reads the live selected price from the .money span
   that is NOT the struck-through compare price.
   Data comes from data-servings / data-netweight rendered by Liquid.
   ============================================================ */
(function () {
  'use strict';

  var seen = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;

  function collect() {
    return [].slice.call(document.querySelectorAll('[data-bulkd-perserve]'));
  }

  /* find the price container associated with a per-serve element:
     it is rendered right after the price block (card) or right after
     .product-page-price (PDP). Walk previous siblings, else climb to
     the nearest card/product root. */
  function priceContainer(el) {
    var prev = el.previousElementSibling;
    while (prev) {
      if (prev.classList &&
          (prev.classList.contains('product-page-price') || prev.classList.contains('price'))) return prev;
      if (prev.querySelector && prev.querySelector('.price, .money')) return prev;
      prev = prev.previousElementSibling;
    }
    return el.closest('.card-wrapper, .product-page-price, .product, .grid__item, li, form') || document;
  }

  /* read the currently-selected price as { n: dollars, prefix: 'NZ$' } */
  function readMoney(container) {
    var ms = container.querySelectorAll('.price .money');
    if (!ms.length) ms = container.querySelectorAll('.money');
    for (var i = 0; i < ms.length; i++) {
      var m = ms[i];
      if (m.closest('.price__compare-price') || m.closest('s') || m.closest('del') || m.closest('.unit-price')) continue;
      var raw = (m.textContent || '').trim();
      var num = parseFloat(raw.replace(/[^0-9.,]/g, '').replace(/,/g, ''));
      if (num && isFinite(num)) {
        var pm = raw.match(/^[^\d\-.,]*/);
        var pfx = (pm && pm[0]) ? pm[0] : '$';
        /* Strip any country code (e.g. "NZ$" -> "$") so we match the theme's money_format,
           which renders the headline price as "$78.00". Some app-injected spans include it. */
        pfx = pfx.replace(/[A-Za-z]/g, '').trim() || '$';
        return { n: num, prefix: pfx };
      }
    }
    return null;
  }

  function update(el) {
    var serv = parseInt(el.getAttribute('data-servings'), 10);
    if (!serv || serv < 1) { el.hidden = true; return; }
    var net = el.getAttribute('data-netweight') || '';
    var money = readMoney(priceContainer(el));
    if (!money) return; /* keep the server-rendered default */
    var per = money.n / serv;
    if (!isFinite(per) || per <= 0) return;
    var txt = money.prefix + per.toFixed(2) + ' / serve · ' + serv + ' serving' + (serv === 1 ? '' : 's') +
              (net ? (' · ' + net) : '');
    var out = el.querySelector('[data-bpx-out]');
    if (out) out.textContent = txt; else el.textContent = txt;
    el.hidden = false;
  }

  function initEl(el) {
    if (seen) { if (seen.has(el)) return; seen.add(el); }
    else { if (el.__bpx) return; el.__bpx = true; }
    update(el);
    var c = priceContainer(el);
    if (c && c !== document && window.MutationObserver) {
      new MutationObserver(function () { update(el); })
        .observe(c, { childList: true, characterData: true, subtree: true });
    }
  }

  function scan() { collect().forEach(initEl); }
  function updateAll() { collect().forEach(update); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  /* Seal toggle: the radio is input[name^="subs_type_"]; Seal rewrites the
     price asynchronously, so recompute a few times after the change. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && /^subs_type_/.test(t.name || '')) {
      [60, 250, 600].forEach(function (d) { setTimeout(updateAll, d); });
    }
  });

  document.addEventListener('shopify:section:load', function () { setTimeout(scan, 50); });
  /* catch lazy-loaded collection cards */
  setTimeout(scan, 1200);
  setTimeout(scan, 3000);
})();
